module.exports = __webpack_public_path__ + "img/img_cx8_open.571d19d9.jpg";